import { Routes } from '@angular/router';
import { HomeComponent } from './component/home/home.component';
import { PagenotfoundComponent } from './component/error/pagenotfound/pagenotfound.component';
import { ResumeComponent } from './component/resume/resume.component';
import { SigninComponent } from './component/account/signin/signin.component';
import { SignoutComponent } from './component/account/signout/signout.component';
import { SignupComponent } from './component/account/signup/signup.component';

export const routes: Routes = [
    { path: '', component: HomeComponent},
    { path: 'resume', component: ResumeComponent},
    { path: 'signin', component: SigninComponent},
    { path: 'signout', component: SignoutComponent},
    { path: 'signup', component: SignupComponent},
    { path: '**', component: PagenotfoundComponent }
  ];